import ContentGroup from './ContentGroup';
import Action from './Action';
import Items from './Items';
import TabbedView from './TabbedView';
import EmptyScreen from './EmptyScreen';

ContentGroup.Action = Action;
ContentGroup.Items = Items;
ContentGroup.TabbedView = TabbedView;
ContentGroup.EmptyScreen = EmptyScreen;

export default ContentGroup;
